import { render, staticRenderFns } from "./ScheduleValue.vue?vue&type=template&id=afafa2dc&scoped=true"
import script from "./ScheduleValue.vue?vue&type=script&lang=js"
export * from "./ScheduleValue.vue?vue&type=script&lang=js"
import style0 from "./ScheduleValue.vue?vue&type=style&index=0&id=afafa2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afafa2dc",
  null
  
)

export default component.exports